module.exports = "/_next/static/images/92eb1a9f978a84eb6d3ba2976e7278a0-derechos-arco-icon.svg.webp";